export default __webpack_public_path__ + "static/media/789712616888205352.ad1dd2e9.png";